import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M4.5 18.885v-1.5h1.808V9.923c0-1.345.415-2.534 1.245-3.567a5.518 5.518 0 0 1 3.197-1.983V2.5h2.5v1.873a5.518 5.518 0 0 1 3.197 1.983c.83 1.033 1.245 2.222 1.245 3.567v7.462H19.5v1.5zm7.498 2.807a1.74 1.74 0 0 1-1.276-.53 1.743 1.743 0 0 1-.53-1.277h3.616c0 .498-.178.924-.532 1.277-.354.354-.78.53-1.278.53m-4.19-4.307h8.384V9.923c0-1.158-.409-2.146-1.228-2.964C14.146 6.14 13.158 5.73 12 5.73s-2.146.409-2.964 1.228c-.819.818-1.228 1.806-1.228 2.964v7.462Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }